import React from 'react';
import classes from './LeftNavigation2.module.css';
import LeftPanel from './LeftPanel/LeftPanel';
import { IconLookup as iconLookup } from '@gscope-mfe/app-bridge';
import LogoutModal from '../../LogoutModal/LogoutModal';
import ModuleInfoDialog from '../../ModuleInfoDialog/ModuleInfoDialog';
import { AppUtils } from '@gscope-mfe/app-bridge';
import { useTranslation } from 'react-i18next';
import { Utilities, Services } from '@gscope-mfe/app-bridge';
import Loader from '../../Loader';
import { MaterialUiCore } from '@gscope-mfe/common-libs';
import { MaterialUiIcons } from '@gscope-mfe/common-libs';
import { useHistory } from 'react-router-dom';

const { makeStyles } = MaterialUiCore;
const { Info } = MaterialUiIcons;
const useStyles = makeStyles(() => ({
    navDrawer: {
        '& .sct-icon': {
            color: '#b3d4f5!important',
            fontSize: '24px',
            padding: '0px 5px 2px 5px',
        },
    },
}));
const LeftNavigation2 = ({ bucketsLookupWithPin, pinModuleFunc, unpinFunc, pinnedBuckets, unpinAll }) => {
    const classesLocal = useStyles();
    const {
        currentMarket,
        logoutHandler,
        headerConfig,
        setHeaderConfig,
        allLangs,
        prefLang,
        currentPage,
        permission,
        supportedlngs,
        showInfoButton,
        infoDialogData,
    } = AppUtils.get();
    const { logo, showLogoutBtn, showLeftNavMobile, showLeftPanel } = headerConfig;
    const { t } = useTranslation('commonLang');
    const [modalShow, setModalShow] = React.useState(false);
    const [showInfoModal, setShowInfoModal] = React.useState(false);

    const [title, setTitle] = React.useState('');
    const [titleKey, setTitleKey] = React.useState('');
    const [focus, setFocus] = React.useState('');
    const [leftPanelChild, setLeftPanelChild] = React.useState('');
    const [isLoading, setIsLoading] = React.useState(false);
    const history = useHistory();
    const LeftPanelShowToggle = () => {
        if (headerConfig.windowWidth <= 425 && showLeftNavMobile) {
            let olderHeaderConfig = { ...headerConfig };
            olderHeaderConfig['showLeftNavMobile'] = false;
            setHeaderConfig(olderHeaderConfig);
        } else if (headerConfig.windowWidth > 425 && showLeftPanel) {
            let olderHeaderConfig = { ...headerConfig };
            olderHeaderConfig['showLeftPanel'] = false;
            setHeaderConfig(olderHeaderConfig);
        }
    };

    const setTitleAndKey = (child) => {
        if (child == 'market') {
            setTitle('Market Selection');
            setTitleKey('marketSelection');
        } else if (child == 'pin') {
            setTitle('Pinned Modules');
            setTitleKey('pinnedModules');
        } else if (child == 'modules') {
            setTitle('Modules');
            setTitleKey('modules');
        } else {
            setTitle('Language Selection');
            setTitleKey('languageSelection');
        }
    };

    const showPanelWithChild = (child) => {
        if (child == 'market' && permission && permission.markets && permission.markets.length == 1) return;
        //if left nav is open
        if (
            (headerConfig.windowWidth > 425 && showLeftPanel) ||
            (headerConfig.windowWidth <= 425 && showLeftNavMobile)
        ) {
            //if child was already open
            if (focus == child) {
                if (headerConfig.windowWidth <= 425) {
                    let olderHeaderConfig = { ...headerConfig };
                    olderHeaderConfig['showLeftNavMobile'] = false;
                    setHeaderConfig(olderHeaderConfig);
                    setFocus('modules');
                    setTitle('Modules');
                    setTitleKey('modules');
                    setLeftPanelChild('modules');
                } else {
                    let olderHeaderConfig = { ...headerConfig };
                    olderHeaderConfig['showLeftPanel'] = false;
                    setHeaderConfig(olderHeaderConfig);
                    if (Object.keys(currentPage).length == 0) setFocus('');
                    else setFocus('modules');
                }
            } else {
                setTitleAndKey(child);
                setFocus(child);
                setLeftPanelChild(child);
            }
        } else {
            //left panel is not open

            setFocus(child);
            setTitleAndKey(child);
            setLeftPanelChild(child);
            if (headerConfig.windowWidth > 425) {
                let olderHeaderConfig = { ...headerConfig };
                olderHeaderConfig['showLeftPanel'] = true;
                setHeaderConfig(olderHeaderConfig);
            } else {
                let olderHeaderConfig = { ...headerConfig };
                olderHeaderConfig['showLeftNavMobile'] = true;
                setHeaderConfig(olderHeaderConfig);
            }
        }
    };

    const homeClick = () => {
        setFocus('');
        let olderHeaderConfig = { ...headerConfig };
        olderHeaderConfig['showLeftPanel'] = false;
        olderHeaderConfig['showLeftNavMobile'] = false;
        setHeaderConfig(olderHeaderConfig);
        history.push('/apphome');
    };

    //Keep the left nav focus on home in larger screens and on modules on mobile screens
    React.useEffect(() => {
        if (headerConfig.windowWidth <= 425 && headerConfig.showLeftNavMobile) {
            setFocus('modules');
            setTitle('Modules');
            setTitleKey('modules');
            setLeftPanelChild('modules');
        } else {
            //For larger screens
            if (!headerConfig.showLeftPanel) {
                if (Object.keys(currentPage).length == 0) setFocus('');
                else setFocus('modules');
                setTitle('');
                setTitleKey('');
            }
        }
    }, [currentPage, headerConfig]);

    return (
        <React.Fragment>
            <Loader show={isLoading} />
            <div
                style={
                    headerConfig.windowWidth <= 425 && !showLeftNavMobile
                        ? { left: '-334px', position: 'absolute' }
                        : { left: '0px' }
                }
                data-testid="secLevelNavdiv"
                className={
                    headerConfig.windowWidth > 425
                        ? `${classes.leftNav} ${classesLocal.navDrawer}`
                        : showLeftNavMobile
                        ? `${classes.leftNavMobile}`
                        : ''
                }
            >
                <div className={classes.gscopeLogo}>
                    <img
                        src={logo}
                        style={headerConfig.windowWidth <= 425 ? { display: 'none' } : {}}
                        alt="Logo"
                        height={35}
                        width={35}
                    />
                </div>
                <div style={{ height: '1px', backgroundColor: '#004484', width: '100%', marginBottom: '1px' }}></div>
                <div id="upperSection" className={classes.upperSection}>
                    <div className={classes.navItemThumbnail} onClick={homeClick}>
                        <div className={focus == '' ? `${classes.focus}` : classes.notFocus} data-testid="home-tab">
                            <span className={`${classes['sct-icon']} sct-icon icon-Home-181x`} />
                            <span>{t('gscope.home')}</span>
                        </div>
                    </div>
                    <div className={classes.navItemThumbnail} onClick={() => showPanelWithChild('pin')}>
                        <div className={focus == 'pin' ? `${classes.focus}` : classes.notFocus} data-testid="pinned">
                            <span className={`${classes['sct-icon']} sct-icon icon-2111_pinLatest`} />
                            <span>{t('pinnedModules')}</span>
                        </div>
                    </div>
                    <div className={classes.navItemThumbnail} onClick={() => showPanelWithChild('modules')}>
                        <div
                            className={focus == 'modules' ? `${classes.focus}` : classes.notFocus}
                            data-testid="modules"
                        >
                            <span
                                className={`${classes['sct-icon']} sct-icon ${
                                    iconLookup['dashboard'] && iconLookup['dashboard'].name
                                }`}
                            />
                            <span>{t('modules')}</span>
                        </div>
                    </div>
                </div>
                <div id="lowerSection" className={classes.lowerSection}>
                    {allLangs && allLangs.length > 0 && (
                        <div className={classes.navItemThumbnailLower} onClick={() => showPanelWithChild('language')}>
                            <div
                                className={focus == 'language' ? `${classes.focus}` : classes.notFocus}
                                data-testid="lang-tab"
                            >
                                <i
                                    className="icon-Globe-181x sct-icon"
                                    style={{ padding: '0px', fontSize: '16px' }}
                                ></i>
                                {allLangs && allLangs.length == 0
                                    ? 'English'
                                    : prefLang && Object.keys(prefLang).length > 0
                                    ? supportedlngs[prefLang.current]
                                        ? supportedlngs[prefLang.current]
                                        : prefLang.current.toLowerCase()
                                    : ''}
                            </div>
                        </div>
                    )}
                    <div
                        className={classes.navItemThumbnailLower}
                        style={
                            permission && permission.markets && permission.markets.length == 1
                                ? { cursor: 'not-allowed' }
                                : {}
                        }
                        onClick={() => showPanelWithChild('market')}
                    >
                        <div
                            className={focus == 'market' ? `${classes.focus}` : classes.notFocus}
                            data-testid="market-tab"
                        >
                            <i
                                className="sct-icon icon-Home-Service-181x"
                                style={{ padding: '0px', fontSize: '16px' }}
                            ></i>
                            {t(currentMarket) == currentMarket ? currentMarket.toUpperCase() : t(currentMarket)}{' '}
                        </div>
                    </div>

                    {showInfoButton ? (
                        <div className={classes.navItemThumbnailLower} onClick={() => setShowInfoModal(true)}>
                            <Info className={classes.infoButton} />
                            {t('info')}
                        </div>
                    ) : (
                        ''
                    )}

                    {showLogoutBtn ? (
                        <div
                            className={classes.navItemThumbnailLower}
                            data-testid="logout-tab"
                            onClick={() => setModalShow(true)}
                        >
                            <i className="icon-Sign-out sct-icon" style={{ padding: '0px', fontSize: '16px' }}></i>
                            {t('logout')}
                        </div>
                    ) : (
                        ''
                    )}
                </div>
                {modalShow && (
                    <LogoutModal
                        data-testid="logout-Mod"
                        modalShow={modalShow}
                        setModalShow={setModalShow}
                        logoutHandler={logoutHandler}
                    />
                )}
                {showInfoModal && (
                    <ModuleInfoDialog
                        data-testid="info-Mod"
                        modalShow={showInfoModal}
                        setModalShow={setShowInfoModal}
                        infoDialogData={infoDialogData}
                    />
                )}
            </div>
            <LeftPanel
                data-testid="left-panel-component"
                title={title}
                titleKey={titleKey}
                pinnedBuckets={pinnedBuckets}
                unpinFunc={unpinFunc}
                unPinAll={unpinAll}
                pinModuleFunc={pinModuleFunc}
                showLeftPanel={headerConfig.windowWidth > 425 ? showLeftPanel : showLeftNavMobile}
                bucketsLookup={bucketsLookupWithPin}
                leftPanelChild={leftPanelChild}
                LeftPanelShowToggle={LeftPanelShowToggle}
                showPanelWithChild={showPanelWithChild}
                langPref={prefLang}
                supportedlngs={supportedlngs}
            />
            {showLeftPanel || showLeftNavMobile ? (
                <div className={classes.overlay} onClick={LeftPanelShowToggle} id="overlay"></div>
            ) : (
                ''
            )}
        </React.Fragment>
    );
};
export default LeftNavigation2;
